<template>
  <v-app>
    <top-nav-bar v-if="isAuthenticated && !isDeactive" @openCart="drawer=true" />

    <v-navigation-drawer
      v-model="drawer"
      app
      right
      temporary
      hideOverlay
      width="400"
    >
      <the-cart @close="drawer=false" />
    </v-navigation-drawer>

    <v-main
      id="main-content"
    >
      <router-view v-if="!isDeactive" />
      <deactive-account v-else />
    </v-main>
  </v-app>
</template>

<script>
import axios from 'axios';

import DeactiveAccount from './components/DeactiveAccount.vue';
import TopNavBar from './components/TopNavBar.vue';
import { mapGetters } from 'vuex';
import TheCart from '@/components/TheCart.vue';

export default {
  name: 'App',
  components: {
    TopNavBar,
    DeactiveAccount,
    TheCart
  },
  data: function () {
    return {
      drawer: false
    };
  },
  computed: {
    ...mapGetters([
      'isAuthenticated',
      'isDeactive'
    ])
  },
  created: function () {
    axios.interceptors.response.use((response) => {
      if (response?.status === 203 && response.headers.latesttoken) {
        const newUserToken = response.headers.latesttoken;
        this.$store.commit('setUserToken', newUserToken);
      }
      return response;
    },
    (err) => {
      return new Promise((resolve, reject) => {
        if ((err?.status === 401 || err.response?.status === 401) && err.config && !err.config.__isRetryRequest) {
          // if you ever get an unauthorized, logout the user
          this.$store.dispatch('logout')
            .then(() => {
              this.$router.push('/login');
            });
        }
        throw err;
      });
    });
  },
  onIdle: function () {
    this.$store.dispatch('logout')
      .then(() => {
        this.$router.push({
          path: '/login',
          query: {
            redirect: this.$route.fullPath
          }
        });
      });
  }
};
</script>
